// Class: starling.events.ResizeEvent

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $hxEnums = require("./../../hxEnums_stub").default;
var $import = require("./../../import_stub").default;
var $extend = require("./../../extend_stub").default;
function starling_events_Event() {return require("./../../starling/events/Event");}
function Std() {return require("./../../Std");}
function js_Boot() {return require("./../../js/Boot");}
function openfl_geom_Point() {return $import(require("openfl/geom/Point"));}

// Constructor

var ResizeEvent = function(type,width,height,bubbles) {
	if(bubbles == null) {
		bubbles = false;
	}
	(starling_events_Event().default).call(this,type,bubbles,new (openfl_geom_Point().default)(width,height));
}

// Meta

ResizeEvent.__name__ = "starling.events.ResizeEvent";
ResizeEvent.__isInterface__ = false;
ResizeEvent.__super__ = (starling_events_Event().default);
ResizeEvent.prototype = $extend((starling_events_Event().default).prototype, {
	get_width: function() {
		return (Std().default).int(((js_Boot().default).__cast(this.data , (openfl_geom_Point().default))).x);
	},
	get_height: function() {
		return (Std().default).int(((js_Boot().default).__cast(this.data , (openfl_geom_Point().default))).y);
	}
});
ResizeEvent.prototype.__class__ = ResizeEvent.prototype.constructor = $hxClasses["starling.events.ResizeEvent"] = ResizeEvent;

// Init

Object.defineProperties(ResizeEvent.prototype,{ width : { get : function () { return this.get_width (); }}, height : { get : function () { return this.get_height (); }}});

// Statics


ResizeEvent.RESIZE = "resize"

// Export

exports.default = ResizeEvent;